import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/content";

const MobileCallBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-call-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-stretch gap-2 p-3 bg-sand/95 backdrop-blur-xl border-t border-line"
    >
      <a
        href={CONTACT.phoneHref}
        data-testid="mobile-call-btn"
        className="flex-1 flex items-center justify-center gap-2 h-12 rounded-full bg-terracotta text-white font-semibold active:scale-[0.98] transition-transform"
      >
        <Phone className="w-5 h-5" /> Call Us Now
      </a>
      <Link
        to="/contact"
        data-testid="mobile-help-btn"
        className="flex-1 flex items-center justify-center gap-2 h-12 rounded-full bg-forest text-sand font-semibold active:scale-[0.98] transition-transform"
      >
        <MessageCircle className="w-5 h-5" /> Get Help
      </Link>
    </div>
  );
};

export default MobileCallBar;
